
import { ArrowLeft, Github, Globe } from "lucide-react";
import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import CustomCursor from "../components/CustomCursor";

const MovieSearchProject = () => {
  return (
    <div className="min-h-screen bg-gradient-to-b from-gray-900 to-gray-800 text-white p-8">
      <CustomCursor />
      <Link 
        to="/" 
        className="inline-flex items-center text-yellow-300 hover:text-yellow-400 transition-colors mb-8"
      >
        <ArrowLeft className="mr-2 h-5 w-5" />
        Back to Portfolio
      </Link>

      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5 }}
        className="max-w-4xl mx-auto"
      >
        <h1 className="text-4xl font-bold mb-6 text-yellow-300">Movie Recommendation Application</h1>
        <p className="text-gray-300 mb-8">Sep 2024 - Dec 2024</p>

        <div className="grid gap-8 md:grid-cols-2 mb-12">
          <motion.div 
            className="bg-gray-800/50 p-6 rounded-xl backdrop-blur-sm"
            whileHover={{ scale: 1.02 }}
          >
            <div className="flex items-center mb-4">
              <h3 className="text-xl font-semibold">Infrastructure Setup</h3>
            </div>
            <p className="text-gray-300">
              Developed and deployed using PHP, React.js, HTML/CSS, and MySQL across Linux-based VM clusters. Implemented RESTful APIs with DMZ clustering and caching, reducing database load by 30%.
            </p>
          </motion.div>

          <motion.div 
            className="bg-gray-800/50 p-6 rounded-xl backdrop-blur-sm"
            whileHover={{ scale: 1.02 }}
          >
            <div className="flex items-center mb-4">
              <h3 className="text-xl font-semibold">Data Security</h3>
            </div>
            <p className="text-gray-300">
              Secured with ZeroTier VPN, ufw firewall rules, two-factor authentication, and encrypted cookie-based session management.
            </p>
          </motion.div>

          <motion.div 
            className="bg-gray-800/50 p-6 rounded-xl backdrop-blur-sm"
            whileHover={{ scale: 1.02 }}
          >
            <div className="flex items-center mb-4">
              <h3 className="text-xl font-semibold">User Management</h3>
            </div>
            <p className="text-gray-300">
              Built secure registration/login flows and personalized watchlists with MySQL validation. Enabled real-time comments via RabbitMQ improving scalability by 50%.
            </p>
          </motion.div>

          <motion.div 
            className="bg-gray-800/50 p-6 rounded-xl backdrop-blur-sm"
            whileHover={{ scale: 1.02 }}
          >
            <div className="flex items-center mb-4">
              <h3 className="text-xl font-semibold">Team Collaboration</h3>
            </div>
            <p className="text-gray-300">
              Managed version control and task distribution among 4 team members, with biweekly code reviews increasing efficiency by 35%.
            </p>
          </motion.div>
        </div>

        <div className="bg-gray-800/30 p-8 rounded-xl backdrop-blur-sm mb-8">
          <h2 className="text-2xl font-bold mb-4 text-yellow-300">Technical Stack</h2>
          <div className="flex flex-wrap gap-3">
            {["PHP", "React.js", "MySQL", "RabbitMQ", "Linux", "ZeroTier", "REST API"].map((tech) => (
              <span 
                key={tech}
                className="bg-yellow-300/10 text-yellow-300 px-3 py-1 rounded-full text-sm"
              >
                {tech}
              </span>
            ))}
          </div>
        </div>

        <div className="flex gap-4">
          <a
            href="https://github.com/healer3771/Movie-Recommendation-Application"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2 bg-yellow-300 text-black px-4 py-2 rounded-lg hover:bg-yellow-400 transition-colors"
          >
            <Github className="h-5 w-5" />
            View on GitHub
          </a>
          <a
            href="https://movie-app.qadeerahmad.work"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2 bg-gray-700 text-white px-4 py-2 rounded-lg hover:bg-gray-600 transition-colors"
          >
            <Globe className="h-5 w-5" />
            Live Demo
          </a>
        </div>
      </motion.div>
    </div>
  );
};

export default MovieSearchProject;
